import React from 'react';
import PropTypes from 'prop-types';
import {MapTools} from 'poly-js-utils';
import LazyImg from '../lazy_img';

const redrawMap = (latlng, officeMapId, address) => {
    if (!latlng) {
        // When geocoding fails the latlng field is set to false
        return;
    }

    const googleMap = MapTools.showGoogleMap(latlng, officeMapId, false);
    const [lat, lng] = latlng;

    google.maps.event.trigger(googleMap, "resize");
    googleMap.setCenter(new google.maps.LatLng(lat, lng));

    const marker = new google.maps.Marker({
        position: {lat, lng},
        map: googleMap,
        title: 'Click to open in new tab'
    });

    marker.addListener('click', () => {
        window.open(
            `http://maps.google.com/?q=${encodeURIComponent(address)}`,
            '_blank'
        );
    });
};

export const loadMap = (officeId, officeMapId, latlng, address) => {
    if (!google || !google.maps) {
        return;
    }
    if (latlng) {
        redrawMap(latlng, officeMapId, address);
    } else {
        MapTools.googleGeocodeAddress(address, (latlng) => {
            redrawMap(latlng, officeMapId, address);
        });
    }
};

class GoogleMap extends React.Component {
    componentDidMount() {
        loadMap(this.props.officeId, this.props.officeMapId, this.props.latlng, this.props.address);
    }

    render() {
        return (
            <div aria-hidden="true" tabIndex="-1">
                {this.props.image ?
                    <div className="photo-map">
                        <div className="left">
                            <LazyImg
                                className="office-location__office-image"
                                src={this.props.image}
                                alt={this.props.street}
                                isBackground={true}
                            />
                        </div>
                        <div id={this.props.officeMapId} className="right google-map" />
                    </div>
                    :
                    <div id={this.props.officeMapId} className="photo-map google-map" />
                }
            </div>
        );
    }
}

GoogleMap.propTypes = {
    office: PropTypes.object,
    officeMapId: PropTypes.string.isRequired
};

export default GoogleMap;



// WEBPACK FOOTER //
// ./components/locations/google_map.jsx